import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id BC337E6C-8077-4D79-9596-6B9EDDA6DE0D
 * name diamond
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/diamond.svg
 * tags
 */
export const DiamondIcon = createSvgIcon(<><path d="M6,2L2,8L12,22L22,8L18,2H6Z" /></>, 'DiamondIcon');
export default DiamondIcon